'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ATTACHMENT_TYPE_ID = exports.ATTACHMENT_TYPE_ID = '@type';
var MENTIONS = exports.MENTIONS = 'MENTIONS';